import { defineStore } from 'pinia'
import api from '@/api/api'
import { useStorage } from '@vueuse/core'
import { ElMessage } from 'element-plus'

export const useIndexSore = defineStore('index', {
    state: () => ({
        strokecColor: '',
        role_id: useStorage('role_id').value || '',
        user_Id: localStorage.getItem('userId') || '',
        userName: useStorage('username').value || '',
        roleName: useStorage('role_name').value || '',
        menuState: JSON.parse(localStorage.getItem('menuState')) || [],
        subMenuState: JSON.parse(localStorage.getItem('subMenuState')) || [],
        menuId: localStorage.getItem('menuId') || 0,
        subMenuId: localStorage.getItem('subMenuId') || 0,
        tabsName: localStorage.getItem('tabsName') || 'first', //话术的tabs  刷新后留在当前位置
        audioUrl: localStorage.getItem('audioUrl') || '',
        isLeftNav: false, //是否显示左侧导航
        isBreadCrumb: false, //是否显示面包屑
        isTopNav: false, //是否显示头部导航
        huashuList: JSON.parse(localStorage.getItem('huashuChangList')) || [],
        styleHeight: window.innerHeight - 105,
        dsjToken: localStorage.getItem('dsjToken') || '',
        smsChannelList: JSON.parse(localStorage.getItem('smsChannelList')) || [],
        isShowCenter: localStorage.getItem('isShowCenter') || true,
        taskMaxRobotCnt: localStorage.getItem('taskMaxRobotCnt') || '',
        enableRobotCnt: localStorage.getItem('enableRobotCnt') || '',
        staff_id: localStorage.getItem('staff_id') || '',
        is_show_crm: localStorage.getItem('is_show_crm') || '',
        userrobotCnt: localStorage.getItem('userrobotCnt') || '',
        userEndTime: localStorage.getItem('userEndTime') || '',
        isGrap: false
    }),
    getters: {
        testGetters(state) {
            // 自动补全！ ✨
            return state.testState
        }
    },
    actions: {
        handleGetDsjToken() {
            return new Promise((resolve, reject) => {
                api.getDsjToken()
                    .then(res => {
                        if (res.code == 200) {
                            this.dsjToken = res.result.dsj_token
                            localStorage.setItem('dsjToken', this.dsjToken)
                            resolve()
                        } else {
                            ElMessage.error(res.msg)
                        }
                    })
                    .catch(() => {})
            })
        },
        handelLogin(data) {
            return new Promise((resolve, reject) => {
                api.login(data)
                    .then(res => {
                        if (res.code == 200) {
                            this.menuId = res.result.menu[0].id
                            useStorage('login_time').value = new Date().toLocaleString()
                            useStorage('token').value = res.result.token
                            this.role_id = res.result.role_id
                            useStorage('role_id').value = this.role_id
                            this.userName = res.result.username
                            useStorage('username').value = res.result.username
                            useStorage('balance').value = res.result.balance
                            useStorage('role_name').value = res.result.role_name
                            useStorage('is_backup').value = res.result.is_backup
                            this.audioUrl = res.result.static_host
                            localStorage.setItem('audioUrl', this.audioUrl)
                            this.userrobotCnt = res.result.robot_cnt
                            localStorage.setItem('userrobotCnt', this.userrobotCnt)
                            localStorage.setItem('userrobotEnableCnt', res.result.enable_robot_cnt)
                            this.roleName = res.result.role_name
                            this.user_Id = res.result.id
                            localStorage.setItem('userId', this.user_Id)
                            this.menuState = res.result.menu
                            localStorage.setItem('menuState', JSON.stringify(this.menuState))
                            this.userEndTime = res.result.expire_at
                            localStorage.setItem('userEndTime', this.userEndTime)
                            localStorage.setItem('site', JSON.stringify(res.result.site))
                            console.log(res.result, 'res.result.task_status')
                            localStorage.setItem('dsj_type', res.result.dsj_type)
                            if (res.result.task_status) {
                                localStorage.setItem('task_status', res.result.task_status)
                            }
                            resolve()
                        } else {
                            ElMessage.error(res.msg)
                        }
                    })
                    .catch(() => {})
            })
        },

        handelStaffLogin(data) {
            return new Promise((resolve, reject) => {
                api.staff_login(data)
                    .then(res => {
                        if (res.code == 200) {
                            this.menuId = res.result.menu[0].id
                            useStorage('login_time').value = new Date().toLocaleString()
                            useStorage('token').value = res.result.token
                            this.role_id = res.result.role_id
                            useStorage('role_id').value = this.role_id
                            this.userName = res.result.username
                            useStorage('username').value = res.result.username
                            useStorage('balance').value = res.result.balance
                            useStorage('role_name').value = res.result.role_name
                            useStorage('is_backup').value = res.result.is_backup
                            this.roleName = res.result.role_name
                            this.user_Id = res.result.id
                            localStorage.setItem('userId', this.user_Id)
                            this.menuState = res.result.menu
                            this.staff_id = res.result.staff_id
                            this.is_show_crm = res.result.is_show_crm
                            localStorage.setItem('staff_id', res.result.staff_id)
                            localStorage.setItem('is_show_crm', res.result.is_show_crm)
                            localStorage.setItem('menuState', JSON.stringify(this.menuState))
                            localStorage.setItem('site', JSON.stringify(res.result.site))
                            if (res.result.task_status) {
                                localStorage.setItem('task_status', res.result.task_status)
                            }
                            resolve()
                        } else {
                            ElMessage.error(res.msg)
                        }
                    })
                    .catch(() => {})
            })
        },
        logout() {
            // 退出登录逻辑，重置状态
            this.$reset()
        }
    }
})
